import { render, staticRenderFns } from "./m-divider.vue?vue&type=template&id=6cf2f732&scoped=true"
import script from "./m-divider.vue?vue&type=script&lang=js"
export * from "./m-divider.vue?vue&type=script&lang=js"
import style0 from "./m-divider.vue?vue&type=style&index=0&id=6cf2f732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf2f732",
  null
  
)

export default component.exports